<template>
  <div class="postSaleBody">
    <div class="postSaleContent">
        <div>
            <h5>申请类型</h5>
            <div class="postSaleType">
                <span @click="selectPostSaleType">{{postSaleTypeSelected.type}}</span>
                <div v-show="isShowMenu" class="menu">
                    <div></div>
                    <ul>
                        <li>选择申请类型<i @click="hideMenu"></i></li>
                        <li @click="choosePostSaleType(item)" v-for="item in postSaleType" :key="item.id">{{item.type}}<i v-show="item.id === postSaleTypeSelected.id"></i></li>
                    </ul>
                </div>
            </div>
        </div>
        <div>
            <h5>联系电话</h5>
            <input class="tel" type="text" placeholder="+86手机号" v-model="tel"/>
        </div>
        <div>
            <h5>是否收到货</h5>
            <div class="goodsState">
                <span>是</span><input type="radio" v-model="goodsState" value="1" />
                <span>否</span><input type="radio" v-model="goodsState" value="0" />
            </div>
        </div>
        <div class="postSaleReason">
            <h5>申请说明</h5>
            <textarea cols="17" rows="10" placeholder="必填，请您申请理由，您可以输入170字" v-model="explain"></textarea>
        </div> 
        <div class="photoList">
            <div class="photoItem" v-for="(item, index) in picParams" :key="index">
                <img :src="item" alt="">
                <i @click="deletePic(index)"></i>
            </div>
            <div class="takePhoto" @click="takePhoto">
                <img src="../assets/imgs/post_sale_pic.png" alt=""/>
                <p>上传照片</p>
                <input type="file" ref="picFile" accept="image/jpeg,image/jpg,image/png" multiple v-show="false" @change="takePhoto2($event)"/>
            </div>
        </div>
    </div>
    <button class="postSaleSubmit" @click="postSaleSubmit">提交</button>
  </div>
</template>

<script>
    import { Toast } from 'vant'
    import {BASE_POST_SALE_PIC_URL, applyAfterSale, uploadImage} from '../api'
    export default {
        name:'ShopMallPostSale',
        props:['orderNo', 'userId', 'phone', 'skuId', 'merchandiseId'],
        data(){
            return{
                tel:"",
                goodsState:"1",
                explain:"",
                isShowMenu:false,
                postSaleType:[
                    {id:1,type:"个人原因"},
                    {id:2,type:"商家通知缺货"},
                    {id:3,type:"未收到货"},
                    {id:4,type:"质量问题"},
                    {id:5,type:"其他"},
                ],
                postSaleTypeSelected:{id:1,type:"个人原因"},
                picParams:[],
                picElement:[]
            }
        },
        methods:{
            getPostSalePicUrl(item){
                return BASE_POST_SALE_PIC_URL + item
            },
            selectPostSaleType(){
                this.isShowMenu = true
            },
            hideMenu(){
                this.isShowMenu = false
            },
            choosePostSaleType(item){
                this.postSaleTypeSelected = item
                this.isShowMenu = false
            },
            takePhoto(){
                this.$refs.picFile.click()
                console.log('zcj', this.$refs.picFile)
            },
            deletePic(index){
                this.picParams.splice(index, 1)
                this.picElement.splice(index, 1)
            },
            takePhoto2(e){
                if(this.picParams.length < 5){
                    var file=e.target.files[0]//获取文件对象
                    var reader = new FileReader();
                    reader.onload = e => {
                        this.picParams.push(e.target.result)
                        this.picElement.push(file)
                    }
                    reader.readAsDataURL(file);
                }else{
                    Toast({message: '最多传五张', position: 'bottom'})
                }
                
            },
            async postSaleSubmit(){
                if(this.tel === ''){
                    Toast({message: '请输入手机号', position: 'bottom'})
                    return;
                }
                if(this.explain === ''){
                    Toast({message: '请输入售后原因', position: 'bottom'})
                    return;
                }
                Toast.loading({
                    message: '提交中...',
                    forbidClick: true,
                });
                var returnPic = '';
                for (var i = 0; i < this.picElement.length; i++){
                    var fd=new FormData()//构造formdata对象
                    fd.append('file',this.picElement[i])//向formdata里面存放键值对
                    let result = await uploadImage(fd);
                    if(result.code === 1){
                        returnPic += result.data + ","
                    }else{
                        Toast({message: `${result.message},请重试`, position: 'bottom'})
                    }
                }
                if(returnPic !== ''){
                    returnPic = returnPic.substring(0, returnPic.length-1);
                }
                const params = {'userId':this.userId, 
                                'phone':this.tel,
                                'orderNo':this.orderNo, 
                                'reason':this.postSaleTypeSelected.id,
                                'returnExplain':this.explain,
                                'merchandiseId':this.merchandiseId,
                                'merchandiseStatus':this.goodsState,
                                'skuId':this.skuId,
                                'returnPic':returnPic}
                let result = await applyAfterSale(params)
                Toast.clear();
                if(result.code === 1){
                    this.$router.push('/prod/refund/success')
                }else{
                    Toast({message: result.message, position: 'bottom'})
                }
            }
        }
    }
</script>

<style scoped>
    .postSaleBody{
        height: 100%;
        background-color: #F0EFF4;
    }
    .postSaleContent{
        background-color: #FFFFFF;
        padding: 4.26666vw;
    }
    .postSaleContent>div{
        height: 12.26666vw;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 4.26666vw;
        margin-bottom: 4.26666vw;
    }
    .postSaleContent div .postSaleType span{
        position: relative;
        font-size: 3.73333vw;
        display: block;
        width: 65.6vw;
        height: 12.26666vw;
        line-height: 12.26666vw;
        padding-left: 4vw;
        border-radius: 2.66666vw;
        background-color: #EFEFEF;
        appearance: none;
        border:none;
        color: #000000;
        text-align: left;
    }
    .postSaleContent div .postSaleType span::after{
        content: "";
        display: inline-block;
        width: 5.86666vw;
        height: 5.86666vw;
        background-image: url(../assets/imgs/post_sale_type_arrow.png);
        background-repeat: no-repeat;
        background-size: 2.93333vw 4.8vw;
        background-position: center;
        position: absolute;
        top: 3.2vw;
        right: 1.86666vw;
    }

    .postSaleContent div .postSaleType .menu{
        position: fixed;
        display: flex;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        z-index: 10;
    }

    .postSaleContent div .postSaleType .menu div{
        flex: 1;
        background-color: #000000;
        opacity: 0.8;
    }

    .postSaleContent div .postSaleType .menu ul{
        position: fixed;
        bottom: 0;
        background-color: #FFFFFF;
    }

    .postSaleContent div .postSaleType .menu li{
        background-color: #FFFFFF;
        width: 100vw;
        height: 12vw;
        border-bottom: 0.26666vw solid #E4E4E4;
        text-align: center;
        line-height: 12vw;
        position: relative;
    }

    .postSaleContent div .postSaleType .menu li i{
        width: 12.26666vw;
        height: 12.26666vw;
        position: absolute;
        right: 0;
        background-image: url(../assets/imgs/post_sale_select_type.png);
        background-size: 3.46666vw 2.4vw;
        background-position: center;
        background-repeat: no-repeat;
    }

    .postSaleContent div .postSaleType .menu li:first-child i{
        width: 12.26666vw;
        height: 12.26666vw;
        position: absolute;
        right: 0;
        background-image: url(../assets/imgs/post_sale_close_menu.png);
        background-size: 3.73333vw 3.73333vw;
        background-position: center;
        background-repeat: no-repeat;
    }


    .postSaleContent div .tel{
        width: 69.6vw;
        height: 12.26666vw;
        font-size: 3.73333vw;
        background-color: #EFEFEF;
        border:none;
        border-radius: 2.66666vw;
        padding-left: 4vw;
        color: #000000;
        box-sizing:border-box;
        outline: none;
    }

    .postSaleContent div .goodsState{
        display: flex;
        align-items: center;
    }
    .postSaleContent div .goodsState span{
        font-size: 4.26666vw;
        font-weight: 800;
        color: #000000;
    }

    .postSaleContent div .goodsState input[type="radio"]{
        width: 11.73333vw;
        height: 11.73333vw;
        appearance: none;
        background-image: url(../assets/imgs/post_sale_no_select.png);
        background-size:4.26666vw 4.26666vw;
        background-position: center;
        background-repeat: no-repeat;
    }
    .postSaleContent div .goodsState input[type="radio"]:checked{
        width: 11.73333vw;
        height: 11.73333vw;
        appearance: none;
        background-image: url(../assets/imgs/post_sale_select.png);
        background-size:4.26666vw 4.26666vw;
        background-position: center;
        background-repeat: no-repeat;
    }
    
    .postSaleContent div.postSaleReason{
        align-items: flex-start;
        height: 21.86666vw;
    }

    .postSaleContent div.postSaleReason h5{
        margin-top: 2.93333vw;
    }

    .postSaleContent div.postSaleReason textarea{
        width: 65.6vw;
        height: 18.93333vw;
        font-size: 3.73333vw;
        padding-top: 2.93333vw;
        background-color: #EFEFEF;
        border:none;
        border-radius: 2.66666vw;
        padding-left: 4.26666vw;
        resize: none;
        color: #000000;
        outline: none;
    }

    .postSaleContent .photoList{
        display: flex;
        min-height: 20vw;
        margin-top: 17.33333vw;
        justify-content:flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        height: auto;
    }

    .postSaleContent .photoList .photoItem{
        width: 19.46666vw;
        height: 19.46666vw;
        position: relative;
        margin-right: 2.66666vw;
        margin-bottom: 2.66666vw;
    }

    .postSaleContent .photoList .photoItem img{
        width: 100%;
        height: 100%;
    }

    .postSaleContent .photoList .photoItem i{
        width: 4.26666vw;
        height: 4.26666vw;
        position: absolute;
        right: -1.13333vw;
        top: -1.13333vw;
        background-image: url(../assets/imgs/post_sale_upload_img_delete.png);
        background-size: 4.26666vw 4.26666vw;
        background-position: center;
    }

    .postSaleContent .photoList .takePhoto{
        width: 19.46666vw;
        height: 19.46666vw;
        border: 1px dashed #979797;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
    }
    .postSaleContent .photoList .takePhoto img{
        width: 8vw;
        height: 8vw;
    }
    .postSaleContent .photoList .takePhoto p{
        color: #A4A4A4;
        font-size: 3.2vw;
        text-align: center;
        margin-top: 1.06666vw;
    }

    .photoMenu{
        width: 100vw;
        height: 100vh;
        position: fixed;
        z-index: 10;
        left: 0;
        top: 0;
    }

    .photoMenu div{
        width: 100vw;
        height: 100vh;
        background-color: #000000;
        opacity: 0.8;
    }

    .photoMenu ul{
        position: fixed;
        left: 5vw;
        bottom: 5vw;
    }

    .photoMenu li{
        background-color: #FFFFFF;
        width: 90vw;
        height: 12vw;
        border-bottom: 0.26666vw solid #E4E4E4;
        text-align: center;
        line-height: 12vw;
    }

    .photoMenu li:first-child{
        border-top-left-radius: 3vw;
        border-top-right-radius: 3vw;
    }
    .photoMenu li:last-child{
        border-bottom-left-radius: 3vw;
        border-bottom-right-radius: 3vw;
    }

    .postSaleSubmit{
        background:linear-gradient(0deg, #F4D19D, #F0B866);
        font-size: 4.8vw;
        color: #6A421F;
        width: 84.26666vw;
        height: 11.73333vw;
        border: none;
        border-radius: 5.86666vw;
        text-align: center;
        line-height: 11.73333vw;
        left: 8vw;
        bottom: 17.73333vw;
        position: fixed;
        
    }
</style>